import React, { Component } from "react";
import { Button, Image, Checkbox, message } from 'antd';
import WidgetAjax from "../../widget/WidgetAjax";
import Config from "../../config/Config";
import './../../css/frame.css';
import './../../css/project.css';
import './index.scss';
import file from '../../img/business/file.png'
import files from '../../img/business/files.png'
import word from '../../img/business/word.png'
import excel from '../../img/business/excel.png'
import pdf from '../../img/business/pdf.png'


import WidgetModal from "./../../widget/WidgetModal"

const filePath = Config.getFilePath();
class Index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listInfo: {},
            pageInfo: {},
            userInfo: {},
            industryInfo: {},
            provinceList: [],
            cityList: [],
            districtList: [],
            tipsInfo: {},
            gradeNum: 0,  // 0  县  1  市  2  省  3  总局
            HJMC: '',
            visible: false,
            srcUrl: '',
            modal: null,
            modelOptions: {
                type: 'message',
                title: '提示',
                index: 0,
                label: 1,
                width: 600,
                message: <div className="sg-index-bg">
                    <div className="sd-middle">
                        <img className='sg-bg-img1' alt='#' src={require('../../img/business/complete.png')} />
                    </div>
                    <div className="sg-filling-layer">申报信息已提交审核，在申报期前都</div>
                    <div className="sg-filling-layer">可对资料进行修改和完善</div>
                </div>,
                isNext: false,
                isOk: true,
                wrapClassName: 'sg-index-model',
                bodyStyle: { padding: 0 },
            },
            isHide: true,
        }
        this.onOk = this.onOk.bind(this);
        this.onOkClick = this.onOkClick.bind(this);
        this.submitBtnFn = this.submitBtnFn.bind(this)
    }
    componentDidMount() {
        this.setState({
            listInfo: this.props.location.state,
            gradeNum: Number(this.props.location.state.gradeNum),
            HJMC: this.props.location.state.HJMC,
        })
        this.querySqHisList(this.props.location.state.SQID)

        this.getUserInfo()
        this.queryAuditList()
    }
    queryAuditList() {
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/entsq/audit_maxnewinfo',
            params: {
                SQID: this.props.location.state.SQID,
                INFO: 'INFO'
            },
            callback: (data) => {
                if (data && data.status === 0 && data.result.BLJG) {
                    if (data.result.HJMC === '县审核') {
                        data.result.HJMC = '待审核'
                    } else if (data.result.HJMC === '县报送') {
                        data.result.HJMC = '待审核'
                    } else if (data.result.HJMC === '县审核驳回') {
                        data.result.HJMC = '驳回'
                    } else if (data.result.HJMC === '县审核退回') {
                        data.result.HJMC = '退回'
                    } else if (data.result.HJMC === '市报送') {
                        data.result.HJMC = '待审核'
                    } else if (data.result.HJMC === '市报送退回') {
                        data.result.HJMC = '退回'
                    } else if (data.result.HJMC === '市报送驳回') {
                        data.result.HJMC = '驳回'
                    } else if (data.result.HJMC === '省审核') {
                        data.result.HJMC = '待审核'
                    } else if (data.result.HJMC === '省报送驳回') {
                        data.result.HJMC = '驳回'
                    } else if (data.result.HJMC === '总局') {
                        data.result.HJMC = '认定入库'
                    } else if (data.result.HJMC === '市审核退回') {
                        data.result.HJMC = '退回'
                    } else if (data.result.HJMC === '市审核驳回') {
                        data.result.HJMC = '驳回'
                    }
                    else {
                    }
                    data.result.BLJG = data.result.BLJG.replace('市报送退回', '退回').replace('县审核驳回', '驳回').replace('县审核退回', '退回').replace('省审核通过', '认定入库').replace('市报送通过', '待审核').replace('待审核通过', '待审核').replace('市报送驳回', '驳回').replace('省审核驳回', '驳回').replace('省报送驳回', '驳回').replace('县报送通过', '待审核').replace('市审核退回', '退回').replace('市审核驳回', '驳回')
                    this.setState({
                        tipsInfo: data.result
                    })

                }
            }
        }, this);
    }
    getUserInfo() {
        let userInfo = sessionStorage.getItem("_user_info_")
        if (userInfo && userInfo != "undefined") {
            let info = JSON.parse(userInfo)
            this.setState({
                userInfo: info
            })
            this.queryEntinfo(info)
        }

    }
    queryEntinfo(info) {
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/entsq/entinfo',
            params: {
                UNISCID: info.uniscid
            },
            callback: (data) => {
                if (data && data.status === 0) {
                    let obj = {}
                    for (var i in this.state.userInfo) {
                        obj[i.toUpperCase()] = this.state.userInfo[i]
                    }
                    this.setState({
                        industryInfo: { ...obj, ...data.result } || {}
                    })

                }
            }
        }, this);
    }
    queryProvince(type, filter, code) {
        let pageInfo = this.state.pageInfo
        let obj = {
            code: type,
            hierarchy: 1,
        }
        if (filter && code) {
            obj.filter = "${" + filter + "}=" + code
        }
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/widget/dimension',
            params: {
                dimension: obj
            },
            callback: (data) => {
                if (data && data.status === 0) {
                    data.results[0].values.forEach(da => {
                        da.label = da.name
                    })

                    if (!filter && !code) {
                        pageInfo.PROVINCESTR = data.results[0].values.find(res => { return res.value === pageInfo.PROVINCE }).name
                        this.setState({
                            provinceList: data.results[0].values,
                            pageInfo: pageInfo
                        })
                    }
                    if (filter === 'D111001' && !this.state.cityList.length) {
                        pageInfo.CITYSTR = data.results[0].values.find(res => { return res.value === pageInfo.CITY }).name
                        this.setState({
                            cityList: data.results[0].values,
                            pageInfo: pageInfo
                        })
                    }
                    if (filter === 'D111002' && !this.state.districtList.length) {
                        pageInfo.COUNTYSTR = data.results[0].values.find(res => { return res.value === pageInfo.COUNTY }).name
                        this.setState({
                            districtList: data.results[0].values,
                            pageInfo: pageInfo
                        })
                    }
                    if (!this.state.cityList.length) {
                        this.queryProvince('D111002', 'D111001', pageInfo.PROVINCE)
                    }
                    if (!this.state.districtList.length && this.state.cityList.length) {
                        this.queryProvince('D111003', 'D111002', pageInfo.CITY)
                    }
                }
            }
        }, this);
    }
    goPage() {
        window.history.back(-1)
    };
    querySqHisList(SQID) {
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/entsq/info',
            params: {
                SQID
            },
            callback: (data) => {
                if (data && data.status === 0) {
                    data.result.SQRESULTS.forEach(da => {
                        if (da.ZBTMLX === '5') {
                            let RESULT = JSON.parse(da.RESULT)
                            RESULT.forEach(async res => {
                                if (res.VCHRSTORAGENAME) {
                                    let newUrl = res.VCHRSTORAGENAME.split(',');
                                    res.imgUrl = filePath + (newUrl && newUrl.length > 1 ? newUrl[1] : newUrl[0]);
                                    if (res.VCHRFILETYPE.indexOf('pdf') !== -1) {
                                        res.img = pdf
                                    } else if (res.VCHRFILETYPE.indexOf('docx') !== -1 || res.VCHRFILETYPE.indexOf('doc') !== -1) {
                                        res.img = word
                                    } else if (res.VCHRFILETYPE.indexOf('xlsm') !== -1 || res.VCHRFILETYPE.indexOf('xlsx') !== -1 || res.VCHRFILETYPE.indexOf('xls') !== -1) {
                                        res.img = excel
                                    } else {
                                        res.img = files
                                    }
                                } else if (res.VCHRFILETYPE.indexOf('png') !== -1 || res.VCHRFILETYPE.indexOf('jpeg') !== -1 || res.VCHRFILETYPE.indexOf('jpg') !== -1 || res.VCHRFILETYPE.indexOf('gif') !== -1) {
                                    this.queryDownload(res, data.result, 'min')
                                } else {
                                    if (res.VCHRFILETYPE.indexOf('pdf') !== -1) {
                                        res.img = pdf
                                    } else if (res.VCHRFILETYPE.indexOf('docx') !== -1 || res.VCHRFILETYPE.indexOf('doc') !== -1) {
                                        res.img = word
                                    } else if (res.VCHRFILETYPE.indexOf('xlsm') !== -1 || res.VCHRFILETYPE.indexOf('xlsx') !== -1 || res.VCHRFILETYPE.indexOf('xls') !== -1) {
                                        res.img = excel
                                    } else {
                                        res.img = files
                                    }
                                    this.queryDownload(res, data.result, 'min')
                                }
                            })
                            da.RESULT = RESULT
                        }
                    })
                    this.setState({
                        pageInfo: data.result
                    })
                    this.queryProvince("D111001")
                }
            }
        }, this);
        if (localStorage.getItem('defaultValue')) {
            let defaultValue;
            let arr = localStorage.getItem('defaultValue').split(',')
            if (arr.length === 3) {
                defaultValue = arr[2]
            }
            WidgetAjax.ajax({
                url: Config.getBasePath() + '/businessSystem/setting',
                params: {
                    SSQXID: defaultValue
                },
                callback: (data) => {
                    console.log(data)
                    if (data && data.status === 0) {
                        if (data.result.STATE === '0') {
                            this.setState({ STATE: data.result.STATE })
                        }
                    }
                }
            });
        }
    }
    getBase64(data) {
        return new Promise((resolve, reject) => {
            const blob = new Blob([data], { type: "image/jpeg" }); //类型一定要写！！！
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    }
    arrayBufferToBlob(arrayBuffer, type) {
        //return new Blob([arrayBuffer], { type: filename });
        let blob = new Blob([arrayBuffer], { type: type });
        const blobUrl = URL.createObjectURL(blob);
        return blobUrl;
    }
    queryDownload(obj, pageInfo, type) {
        let fd = new FormData();
        fd.append("id", obj.ID);
        if (type) {
            fd.append("imgsize", type);
        }
        this.setState({ DownloadType: type })

        WidgetAjax.ajax({
            url: Config.getBasePath() + '/attachment/info',
            params: fd,
            callback: async (data) => {

                let value = data.result;

                if (value.VCHRDESCRIPTION && value.VCHRDESCRIPTION !== "" && type == undefined) {
                    obj.imgUrl = filePath + value.VCHRDESCRIPTION
                    this.setState({
                        pageInfo: pageInfo
                    })
                    return
                } else {
                    let newUrl = value.VCHRSTORAGENAME.split(',');
                    if (type && newUrl && newUrl.length > 2) {
                        obj.imgUrl = filePath + newUrl[1]
                    } else {
                        obj.imgUrl = filePath + newUrl[0]
                    }
                    this.setState({
                        pageInfo: pageInfo
                    })
                    return
                }
            }
        });
    }
    goFilling() {
        this.props.history.push({ pathname: "/home/filling", state: { SQID: this.props.location.state.SQID, SFTJ: this.props.location.state.SFTJ } });
    }
    seeImg(da) {
        window.open(da.fileUrl)
    }
    submitBtnFn() {
        let obj = {
            ZJ: this.props.location.state.SQID,         // 主键ID
            TASKID: this.state.pageInfo.TASKID,     // 任务ID
            JYZSFZ: this.state.pageInfo.JYZSFZ,     // 经营者身份证号
            JYZSJH: this.state.pageInfo.JYZSJH,     // 经营者手机号
            XNJYRS: this.state.pageInfo.XNJYRS,     // 吸纳就业人数
            JNSBRS: this.state.pageInfo.JNSBRS,     // 缴纳社保人数
            YYSR: this.state.pageInfo.YYSR,       // 营业收入(万元)
            JLR: this.state.pageInfo.JLR,        // 净利润(万元)
            PROFILE: this.state.pageInfo.PROFILE,    // 个体户简介
            SQTYPE: this.state.pageInfo.SQTYPE,     // 申请类型 1名 2 特 3优 4新
            SUMSCORE: this.state.pageInfo.SUMSCORE,   // 当前申请项总得分
            SQRESULTS: this.state.pageInfo.SQRESULTS,  // 申请指标结果集
            PROVINCE: this.state.pageInfo.PROVINCE,   // 省
            CITY: this.state.pageInfo.CITY,       // 市
            COUNTY: this.state.pageInfo.COUNTY,     // 区
            ISBF: this.state.pageInfo.ISBF,       // 是否帮扶
            SFTJ: 'Y'
        }
        let arr = []
        this.state.pageInfo.SQRESULTS.forEach(da => {
            let obj = {
                ZBMC: da.ZBMC,
                RESULT: da.RESULT,
                SCORE: 0,
                ZBTMLX: da.ZBTMLX,
                ZBID: da.ZBID
            }
            if (da.ZBTMLX === '2') {
                let ZBBZZ = JSON.parse(da.ZBBZZ)
                let info = ZBBZZ.find(res => { return res.name === da.RESULT })
                obj.SCORE = info ? info.score : da.ZBNUM
            }
            if (da.ZBTMLX === '3') {
                let ZBBZZ = JSON.parse(da.ZBBZZ)
                let list = ZBBZZ.filter(res => { return da.RESULT.indexOf(res.name) > -1 })
                obj.SCORE = da.RESULT && da.RESULT !== '[]' && da.RESULT !== '{}' && da.RESULT !== 'undefined' && da.RESULT !== 'null' && da.RESULT !== 'Null' && da.RESULT !== 'NULL' ? list.reduce((total, num) => { return total + num.score }, 0) : 0
                obj.RESULT = JSON.stringify(obj.RESULT)
            }
            if (da.ZBTMLX === '1') {
                // let info = da.ZBBZZ.find(res=>{return res.name === da.RESULT})
                obj.SCORE = da.RESULT === '是' ? da.ZBNUM : 0
            }
            if (da.ZBTMLX === '4') {
                obj.SCORE = da.RESULT && da.RESULT !== '[]' && da.RESULT !== '{}' && da.RESULT !== 'undefined' && da.RESULT !== 'null' && da.RESULT !== 'Null' && da.RESULT !== 'NULL' ? da.ZBNUM : 0
            }
            if (da.ZBTMLX === '5') {
                let arr = []
                obj.RESULT.forEach(da => {
                    arr.push({ ID: da.ID, VCHRFILETYPE: da.VCHRFILETYPE })
                })
                obj.RESULT = JSON.stringify(arr)
                obj.SCORE = obj.RESULT && obj.RESULT !== '[]' && obj.RESULT !== '{}' && obj.RESULT !== 'undefined' && obj.RESULT !== 'null' && obj.RESULT !== 'Null' && obj.RESULT !== 'NULL' ? da.ZBNUM : 0

            }
            arr.push(obj)
        })
        obj.SQRESULTS = arr
        this.queryUpdate(obj)
    }
    queryUpdate(params) {
        this.modal.onClose();
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/entsq/update',
            params: params,
            callback: (data) => {
                if (data && data.status === 0) {
                    message.success('申报信息已提交成功！');
                    this.setState({
                        listInfo: {
                            ...this.state.listInfo,
                            HJMC: '待审核'
                        },
                        gradeNum: Number(this.props.location.state.gradeNum),
                        HJMC: '待审核',
                    })
                    this.querySqHisList(this.props.location.state.SQID)
                    this.modal.onClose();
                } else {
                    message.success(data.message);
                }
            }
        }, this);
    }
    onOk(type) {
        this.submitBtnFn()
    }
    onOkClick(type) {

    }
    onRef = (ref) => {
        this.modal = ref;
    };
    submitBtn() {
        const { modelOptions } = this.state;
        modelOptions.label = 2
        modelOptions.width = 600
        modelOptions.okText = '确认'

        modelOptions.message = <div className="sg-index-bg">
            <div className="sd-middle" style={{ margin: '20px 0' }}>
                <svg t="1688104158159" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3910" width="40" height="40"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296z m32 440c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z" fill="#ff0000" p-id="3911"></path></svg>
            </div>
            <div className="sg-filling-layer a11">您确认提交申报信息吗？</div>
            <div className="sg-filling-layer b11">请确认申报信息准确无误，可在申报期内进行修改，进入审核后将不可修改</div>
        </div>
        this.setState({
            modelOptions: modelOptions,
        })
        this.modal.open();
    }
    visibleChange = () => {
        const { pageInfo, DownloadType } = this.state;

        pageInfo.SQRESULTS.forEach(da => {
            if (da.ZBTMLX === '5' && DownloadType) {
                console.log(da.RESULT);
                let RESULT = da.RESULT
                RESULT.forEach(async res => {
                    if (res.VCHRSTORAGENAME) {
                        let newUrl = res.VCHRSTORAGENAME.split(',');
                        res.imgUrl = filePath + (newUrl[0]);
                        if (res.VCHRFILETYPE.indexOf('pdf') !== -1) {
                            res.img = pdf
                        } else if (res.VCHRFILETYPE.indexOf('docx') !== -1 || res.VCHRFILETYPE.indexOf('doc') !== -1) {
                            res.img = word
                        } else if (res.VCHRFILETYPE.indexOf('xlsm') !== -1 || res.VCHRFILETYPE.indexOf('xlsx') !== -1 || res.VCHRFILETYPE.indexOf('xls') !== -1) {
                            res.img = excel
                        } else {
                            res.img = files
                        }
                    } else
                        if (res.VCHRFILETYPE.indexOf('png') !== -1 || res.VCHRFILETYPE.indexOf('jpeg') !== -1 || res.VCHRFILETYPE.indexOf('jpg') !== -1 || res.VCHRFILETYPE.indexOf('gif') !== -1) {
                            await this.queryDownload(res, pageInfo)
                        } else {
                            if (res.VCHRFILETYPE.indexOf('pdf') !== -1) {
                                res.img = pdf
                            } else if (res.VCHRFILETYPE.indexOf('docx') !== -1 || res.VCHRFILETYPE.indexOf('doc') !== -1) {
                                res.img = word
                            } else if (res.VCHRFILETYPE.indexOf('xlsm') !== -1 || res.VCHRFILETYPE.indexOf('xlsx') !== -1 || res.VCHRFILETYPE.indexOf('xls') !== -1) {
                                res.img = excel
                            } else {
                                res.img = files
                            }
                            await this.queryDownload(res, pageInfo)
                        }
                })
            }
        })
    }
    render() {
        const { listInfo, pageInfo, industryInfo, tipsInfo, visible, srcUrl, modelOptions, isHide, STATE } = this.state;

        const ENTTYPE_OBJ = {
            '1': '生存',
            '2': '成长',
            '3': '发展'
        }
        const SQTYPE_OBJ = {
            '1': '知名',
            '2': '特色',
            '3': '优质',
            '4': '新兴',
        }

        let arr = STATE === '0' ? ['县审核退回', '市报送退回', '省审核退回', '市审核退回'] : ['草稿', '县审核退回', '市审核退回', '省审核退回', '待审核', '市报送退回']
        let arr1 = STATE === '0' ? ['县审核退回', '市报送退回', '省审核退回', '市审核退回'] : ['县审核退回', '市审核退回', '省审核退回', '待审核', '市报送退回']
        console.log(pageInfo.SQRESULTS, 'pageInfo.SQRESULTS---');
        return (
            <div key={pageInfo.UNISCID} data-component="information" >
                <div className="sg-information-all">
                    <div className="sg-login-top sd-start">
                        <div onClick={this.goPage} className="sd-start">
                            <img className='sg-information-img' alt='#' src={require('../../img/business/upPage.png')} />
                            <span className="sg-top-font" style={{ color: '#357AC5' }}>返回</span>
                        </div>

                    </div>
                    <div className="sg-notice">
                        <div className="sg-notice-center">
                            <div className="sg-center-top sd-start" style={{ borderBottom: '1px solid #D6D4D4', background: 'linear-gradient(180deg, #FFFFFF 0%, #F3F6F8 100%)' }}>
                                <span className="sg-center-font">信息详情</span>
                            </div>
                            <div className="sg-center-middle sd-columnCenter" style={{ paddingBottom: '0' }}>
                                <div className="sg-middle-list">
                                    <div className="sg-list-top sd-middle">
                                        <span className="sg-top-font22">申报任务：{listInfo.TASKNAME}</span>
                                        <span className="sg-top-font22">申报方式：{pageInfo.SBFS === '1' ? '自主申报' : '推荐申报'}</span>
                                        <span className="sg-top-font22">推荐单位：{pageInfo.TJDW || '-'}</span>
                                        <span className="sg-top-font22">申报时间：{listInfo.creating_time}</span>
                                    </div>
                                    {/* <div className="sg-information-label">
                                        <img className='sg-middle-img' alt='#' src={require('../../img/business/informationBg.png')} />
                                        <div className="sg-information-center sd-middle">
                                            <div className="sg-information-div sd-middle">
                                        
                                                <div className="sg-line-font" style={{ color: gradeNum === 0 ? HJMC.indexOf('退回') === -1 && HJMC.indexOf('驳回') === -1 ? '#666666' : '#BB483F' : '#025E58' }}>{gradeNum === 0 ? HJMC : '审核通过'}</div>
                                            
                                                <div className="sg-information-list sd-middle"></div>
                                                <div className="sg-information-line sd-columnCenter">
                                                
                                                    <div className='sg-line-img'></div>
                                                
                                                </div>
                                                
                                                <div className="sg-information-department">区/县级主管部门</div>
                                            </div>
                                            <div className="sg-information-div sd-middle">
                                        
                                                <div className="sg-line-font" style={{ color: gradeNum > 1 ? '#025E58' : (gradeNum === 1 && HJMC.indexOf('退回') === -1 && HJMC.indexOf('驳回') === -1) || gradeNum < 1 ? '#666666' : '#BB483F' }}>{gradeNum > 1 ? '审核通过' : ''}{gradeNum === 0 ? '未审核' : ''}{gradeNum === 1 ? HJMC : ''}</div>
                                            
                                                <div className="sg-information-list sd-middle"></div>
                                                <div className="sg-information-line sd-columnCenter">
                                                
                                                    <div className='sg-line-img'></div>
                                                    
                                                </div>
                                                
                                                <div className="sg-information-department">市级主管部门</div>
                                            </div>
                                            <div className="sg-information-div sd-middle">
                                        
                                                <div className="sg-line-font" style={{ color: gradeNum > 2 ? '#025E58' : (gradeNum === 2 && HJMC.indexOf('退回') === -1 && HJMC.indexOf('驳回') === -1) || gradeNum < 2 ? '#666666' : '#BB483F' }}>{gradeNum > 2 ? '审核通过' : ''}{gradeNum < 2 ? '未审核' : ''}{gradeNum === 2 ? HJMC : ''}</div>
                                                
                                            
                                                <div className="sg-information-list sd-middle"></div>
                                                <div className="sg-information-line sd-columnCenter">
                                                
                                                    <div className='sg-line-img'></div>

                                                </div>
                                                
                                                <div className="sg-information-department">省级主管部门</div>

                                            </div>
                                            <div className="sg-information-div sd-middle">
                                        
                                                <div className="sg-line-font" style={{ color: gradeNum < 3 ? '#666666' : '#025E58' }}>{gradeNum === 3 ? '已入库' : '未审核'}</div>

                                            
                                                <div className="sg-information-list sd-middle"></div>
                                                <div className="sg-information-line sd-columnCenter">
                                                
                                                    <div className='sgs-line-img'></div>

                                                </div>
                                                
                                                <div className="sg-information-department">国家市场监督管理总局</div>
                                            </div>

                                        </div>
                                    </div> */}

                                    <div className="sg-label-tip sd-start">
                                        <div className="sg-tip-label">
                                            <img className='sg-label-img' alt='#' src={require('../../img/business/informationLabel.png')} />
                                            <div className="sg-label-font sd-middle">{tipsInfo && tipsInfo.BLSJ ? tipsInfo.BLSJ : listInfo.creating_time}</div>
                                        </div>
                                        {/* {tipsInfo && tipsInfo.HJMC ? tipsInfo.HJMC : ''} */}
                                        <div className="sg-tip-font" style={{ display: tipsInfo && tipsInfo.BLSJ ? "block" : "none" }}>您的申请{tipsInfo.BLJG === '通过' ? tipsInfo.HJMC : ''}{tipsInfo && tipsInfo.BLJG ? tipsInfo.BLJG : ''}。<span style={{ display: tipsInfo && tipsInfo.BLJG && tipsInfo.BLJG.indexOf('通过') === -1 ? "inline-block" : "none" }}>修改意见：{tipsInfo && tipsInfo.BLYJ ? tipsInfo.BLYJ : ''}</span></div>
                                        <div className="sg-tip-font" style={{ display: !tipsInfo || !tipsInfo.BLSJ ? "block" : "none" }}>当前审核进度：暂未进入审批流程，请耐心等待</div>
                                    </div>
                                </div>

                                <div className="sg-middle-list">
                                    <div className="sg-center-top sd-start sg-border">
                                        <span className="sg-center-font">基础信息</span>
                                    </div>
                                    <div className="sg-list-li sd-spaceBetween">
                                        <div className="sg-li-title sg-left-none">个体工商户名称/字号：</div>
                                        <div className="sg-li-li sd-start">
                                            <div className="li-li-view">{industryInfo.ENTNAME}</div>
                                        </div>
                                        <div className="sg-li-title">统一社会信用代码：</div>
                                        <div className="sg-li-li sd-start">
                                            <div className="li-li-view">{industryInfo.UNISCID}</div>
                                        </div>
                                    </div>
                                    <div className="sg-list-li sd-spaceBetween">
                                        <div className="sg-li-title sg-left-none">经营者姓名：</div>
                                        <div className="sg-li-li sd-start">
                                            <div className="li-li-view">{industryInfo.NAME}</div>
                                        </div>
                                        <div className="sg-li-title">经营者手机号码：</div>
                                        <div className="sg-li-li sd-start">
                                            <div className="li-li-view">{pageInfo.JYZSJH}</div>
                                        </div>
                                    </div>
                                    <div className="sg-list-li sd-spaceBetween">
                                        <div className="sg-li-title sg-left-none">经营者身份证号：</div>
                                        <div className="sg-li-li sd-start">
                                            <div className="li-li-view">{pageInfo.JYZSFZ}</div>
                                        </div>
                                        <div className="sg-li-title">注册日期：</div>
                                        <div className="sg-li-li sd-start">
                                            <div className="li-li-view">{industryInfo.ESTDATE}</div>
                                        </div>
                                    </div>
                                    <div className="sg-list-li sd-spaceBetween">
                                        <div className="sg-li-title sg-left-none">省份/地市/区县：</div>
                                        <div className="sg-li-li sd-start">
                                            <div className="li-li-view">{pageInfo.PROVINCE_STR}{pageInfo.PROVINCE_STR == pageInfo.CITY_STR ? '' : '/'}{pageInfo.PROVINCE_STR == pageInfo.CITY_STR ? '' : pageInfo.CITY_STR}/{pageInfo.COUNTY_STR}</div>
                                        </div>
                                    </div>
                                    <div className="sg-list-li sd-spaceBetween">
                                        <div className="sg-li-title sg-left-none">组成形式：</div>
                                        <div className="sg-li-li sd-start">
                                            <div className="li-li-view">{industryInfo.COMPFORM}&nbsp;</div>
                                        </div>
                                        {/* <div className="sg-li-title">三型：</div>
                                        <div className="sg-li-li sd-start">
                                            <div className="li-li-view">{ENTTYPE_OBJ[industryInfo.ENTTYPE_SX]}&nbsp;</div>
                                        </div> */}
                                        <div className="sg-li-title">登记机关：</div>
                                        <div className="sg-li-li sd-start">
                                            <div className="li-li-view">{industryInfo.REGORG}</div>
                                        </div>
                                    </div>
                                    <div className="sg-list-li sd-spaceBetween">
                                        <div className="sg-li-title sg-left-none">经营场所：</div>
                                        <div className="sg-li-li sd-start">
                                            <div className="li-li-view">{industryInfo.OPLOC}</div>
                                        </div>

                                    </div>
                                    <div className="sg-list-li sd-spaceBetween">
                                        <div className="sg-li-title sg-left-none">吸纳就业人数（人)：</div>
                                        <div className="sg-li-li sd-start">
                                            <div className="li-li-view">{pageInfo.XNJYRS}</div>
                                        </div>
                                        <div className="sg-li-title">缴纳社保人数（人）:</div>
                                        <div className="sg-li-li sd-start">
                                            <div className="li-li-view">{pageInfo.JNSBRS}</div>
                                        </div>
                                    </div>
                                    <div className="sg-list-li sd-spaceBetween">
                                        <div className="sg-li-title sg-left-none">年营业收入（万元）:</div>
                                        <div className="sg-li-li sd-start">
                                            <div className="li-li-view">{pageInfo.YYSR}</div>
                                        </div>
                                        <div className="sg-li-title">年净利润（万元）:</div>
                                        <div className="sg-li-li sd-start">
                                            <div className="li-li-view">{pageInfo.JLR}</div>
                                        </div>
                                    </div>
                                    <div className="sg-list-li sd-spaceBetween">
                                        <div className="sg-li-title sg-left-none">经营范围:</div>
                                        <div className="sg-li-li sd-start">
                                            <div className="li-li-view">{industryInfo.OPSCOPE}</div>
                                        </div>
                                    </div>
                                    <div className="sg-list-li sd-spaceBetween">
                                        <div className="sg-li-title sg-left-none">个体工商户介绍/简介:</div>
                                        <div className="sg-li-li sd-start">
                                            <div className="li-li-view">{pageInfo.PROFILE}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="sg-middle-list" style={{ marginBottom: '0' }}>
                                    <div className="sg-center-top sd-start sg-border">
                                        <span className="sg-center-font" style={{ position: 'absolute', color: '#fff' }}> {SQTYPE_OBJ[pageInfo.SQTYPE]}</span>
                                        <img src={require('../../img/business/lineBg.png')} alt="#" className="sg-center-img"></img>
                                    </div>
                                    {
                                        pageInfo.SQRESULTS && pageInfo.SQRESULTS.map((res, i) => {
                                            let str = ''
                                            if (res.ZBTMLX === '1' || res.ZBTMLX === '2' || res.ZBTMLX === '4') {
                                                str = <div className="sg-list-li sd-spaceBetween" key={i}>
                                                    <div className="sg-li-li sd-start sg-left-none" style={{ background: 'none' }}>
                                                        <div className="li-li-view">{i + 1 + '. '}{res.ZBMC}</div>
                                                    </div>
                                                    <div className="sg-li-li sd-start">
                                                        <div className="li-li-view">{res.RESULT} </div>
                                                    </div>
                                                </div>
                                            }
                                            if (res.ZBTMLX === '5') {
                                                str = <div className="sg-list-li sd-spaceBetween" key={i}>
                                                    <div className="sg-li-li sd-start sg-left-none" style={{ background: 'none' }}>{i + 1 + '. '}{res.ZBMC}</div>
                                                    <div className="sg-li-li sd-start sd-start sd-wrap">
                                                        <div style={{ width: '80%', display: 'flex', flexWrap: 'wrap' }}>
                                                            <Image.PreviewGroup>
                                                                {
                                                                    res.RESULT && res.RESULT.map((da) => {

                                                                        return (
                                                                            <div className="sg-li-view">
                                                                                {
                                                                                    da.VCHRFILETYPE === '.png' || da.VCHRFILETYPE === '.jpeg' || da.VCHRFILETYPE === '.jpg' ||
                                                                                        da.VCHRFILETYPE === '.gif' || da.VCHRFILETYPE === '.webp' || da.VCHRFILETYPE === '.bmp' || da.VCHRFILETYPE === '.pict'
                                                                                        ?
                                                                                        <Image className='sg-li-img' src={da.imgUrl} preview={{ src: da.imgUrl }} onClick={this.visibleChange} />
                                                                                        :
                                                                                        da.fileUrl ?
                                                                                            <div onClick={() => { window.open(da.fileUrl) }}>{/* 提供下载选项 */}
                                                                                                <Image className='sg-li-img' src={da.img ? da.img : da.imgUrl} />
                                                                                            </div>
                                                                                            :
                                                                                            <a target="_blank" href={da.imgUrl ? da.imgUrl : da.fileUrl}>{/* 提供下载选项 */}
                                                                                                <Image className='sg-li-img' src={da.img ? da.img : da.imgUrl} />
                                                                                            </a>
                                                                                }
                                                                            </div>
                                                                        );
                                                                    })
                                                                }
                                                            </Image.PreviewGroup>
                                                        </div>

                                                    </div>
                                                </div>
                                            }
                                            if (res.ZBTMLX === '3') {
                                                str = <div className="sg-list-li sd-spaceBetween" key={i}>
                                                    <div className="sg-li-li sd-start sg-left-none" style={{ background: 'none' }}>
                                                        <div className="li-li-view">{i + 1 + '. '}{res.ZBMC}</div>
                                                    </div>
                                                    <div className="sg-li-li sd-start">
                                                        {/* <div className="li-li-view">{res.RESULT}</div> */}
                                                        <Checkbox.Group disabled value={JSON.parse(res.RESULT)}>
                                                            {
                                                                JSON.parse(res.ZBBZZ).map((item, num) => {
                                                                    return <Checkbox value={item.name}>{item.name}</Checkbox>
                                                                })
                                                            }
                                                        </Checkbox.Group>
                                                    </div>
                                                </div>
                                            }
                                            return str
                                        })
                                    }
                                </div>

                                <div className="sg-middle-list sd-middle" style={{ paddingTop: '48px', paddingBottom: '32px' }}>

                                    <Button
                                        type={"primary"}
                                        onClick={() => { this.goFilling() }}
                                        disabled={this.props.location.state.isUpdate}
                                        className="sg-list-btn sd-middle"
                                        style={{ display: arr.includes(listInfo.HJMC) ? "flex" : "none", background: this.props.location.state.isUpdate == false ? '#357AC5' : '' }}
                                    >修改</Button>
                                    <Button type="primary" onClick={() => { this.submitBtn() }} className="sg-list-btn sd-middle" style={{ display: arr1.includes(listInfo.HJMC) ? "flex" : "none", background: '#357AC5' }}>提交</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <WidgetModal options={modelOptions} onRef={this.onRef} isHide={isHide} onOk={this.onOk} onOkClick={this.onOkClick} onCancel={this.onOkClick}></WidgetModal>
            </div>
        )
    }
}

export default Index
